// To add a new toy:
//
// 1. Add the svg component in this folder.
// 2. Import the component here.
// 3. Add the goody to `toyOptions` here.
// 4. Add the goody to constants.
// 5. Add a new story in src/stories/toys.js.

import React from 'react';

import Yarn from './Yarn';
import Mouse from './Mouse';
import Pizza from './Pizza';
import Fishbones from './Fishbones';
import SoccerBall from './SoccerBall';
import Donut from './Donut';
import Fishbowl from './Fishbowl';
import Campfire from './Campfire';
import MagicWand from './MagicWand';
import IceCream from './IceCream';
import Coffee from './Coffee';
import MiniGolf from './MiniGolf';
import Flamingo from './Flamingo';
import Rocketship from './Rocketship';
import FoamFinger from './FoamFinger';
import BonsaiTree from './BonsaiTree';
import Wine from './Wine';
import Synth from './Synth';
import Martini from './Martini';
import Bone from './Bone';
import Popsicle from './Popsicle';
import Sushi from './Sushi';
import Strawberry from './Strawberry';
import Flowers from './Flowers';
import Cake from './Cake';
import Dough from './Dough';
import HotDog from './HotDog';
import Burger from './Burger';
import Cactus from './Cactus';
import RubberDuck from './RubberDuck';
import Egg from './Egg';
import Steak from './Steak';
import JazzCup from './JazzCup';
import Gold from './Gold';
import Money from './Money';

const toyOptions = {
	'toy-Yarn': Yarn,
	'toy-Mouse': Mouse,
	'toy-Pizza': Pizza,
	'toy-Fishbones': Fishbones,
	'toy-SoccerBall': SoccerBall,
	'toy-Donut': Donut,
	'toy-Fishbowl': Fishbowl,
	'toy-Campfire': Campfire,
	'toy-MagicWand': MagicWand,
	'toy-IceCream': IceCream,
	'toy-Coffee': Coffee,
	'toy-MiniGolf': MiniGolf,
	'toy-Flamingo': Flamingo,
	'toy-Rocketship': Rocketship,
	'toy-FoamFinger': FoamFinger,
	'toy-BonsaiTree': BonsaiTree,
	'toy-Wine': Wine,
	'toy-Synth': Synth,
	'toy-Martini': Martini,
	'toy-Bone': Bone,
	'toy-Popsicle': Popsicle,
	'toy-Sushi': Sushi,
	'toy-Strawberry': Strawberry,
	'toy-Flowers': Flowers,
	'toy-Cake': Cake,
	'toy-Dough': Dough,
	'toy-HotDog': HotDog,
	'toy-Burger': Burger,
	'toy-Cactus': Cactus,
	'toy-RubberDuck': RubberDuck,
	'toy-Egg': Egg,
	'toy-Steak': Steak,
	'toy-JazzCup': JazzCup,
	'toy-Gold': Gold,
	'toy-Money': Money,
};

function Toy(props) {

	const ThisToy = toyOptions[props.toy];

	if (!ThisToy) {
		return null;
	}

	if (!props.toy || !ThisToy || props.kitten) {
		return null;
	}

	return <ThisToy />;
}

export default Toy;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/_Toy.js